import React from 'react';
import { techStackIcons } from './TechIcons';

const truncateDescription = (description, maxLength = 100) => {
  if (!description) return '';
  return description.length > maxLength
    ? `${description.substring(0, maxLength)}...`
    : description;
};

const truncateTitle = (title, maxLength = 7) => {
  if (!title) return '';
  return title.length > maxLength
    ? `${title.substring(0, maxLength)}...`
    : title;
};

const WorkItem = ({ imgUrl, title, description, demoLink, codeLink, category, tech, platform }) => {
  const handleButtonClick = (url) => {
    if (url && typeof url === 'string') {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  const platformData = React.useMemo(() => {
    try {
      return Array.isArray(platform) ? platform : JSON.parse(platform || '[]');
    } catch (e) {
      console.error('Error parsing platform data:', e);
      return [];
    }
  }, [platform]);

  return (
    <div className="work__item" style={{ backgroundImage: `url(${imgUrl || ''})` }}>
      <div className="work__content">
        <div className="work__name">{truncateTitle(title)}</div>
        {platformData.length > 0 && (
          <div className="work__platforms">
            {platformData.map((p, index) => (
              <span key={index} className="platform-badge">
                {p}
              </span>
            ))}
          </div>
        )}
        <div className="work__description">
          {truncateDescription(description)}
        </div>
        <div className="work__tech-stack">
          {tech && tech.map((item, index) => {
            const techKey = Object.keys(techStackIcons).find(
              key => key.toLowerCase() === item.toLowerCase()
            );
            return techKey ? (
              <i 
                key={index}
                className={`tech-icon ${techStackIcons[techKey].icon}`}
                style={{ color: techStackIcons[techKey].color }}
                title={item}
              ></i>
            ) : null;
          })}
        </div>
        <div className="work__button-group">
          {category === 'design' ? (
            <button
              type="button"
              onClick={() => handleButtonClick(demoLink)}
              className="work__button figma"
            >
              Appreciate
              <i className="uil uil-heart figma-icon"></i>
            </button>
          ) : (
            <button
              type="button"
              onClick={() => handleButtonClick(codeLink)}
              className="work__button source-code"
            >
              Source Code
              <i className="uil uil-github github-icon"></i>
            </button>
          )}
          <button
            type="button"
            onClick={() => handleButtonClick(demoLink)}
            className="work__button details"
          >
            Details
            <i className={`uil ${category === 'design' ? 'uil-eye' : 'uil-arrow-right'} details-icon`}></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkItem;
